var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/status/components/card.tsx";
import "core-js/modules/es.array.includes.js";
import classnames from 'classnames';
import { List as ImmutableList } from 'immutable';
import React, { useState, useEffect } from 'react';
import Blurhash from 'soapbox/components/blurhash';
import Icon from 'soapbox/components/icon';
import { HStack, Stack, Text } from 'soapbox/components/ui';
import { normalizeAttachment } from 'soapbox/normalizers';
const trim = (text, len) => {
  const cut = text.indexOf(' ', len);
  if (cut === -1) {
    return text;
  }
  return text.substring(0, cut) + (text.length > len ? '…' : '');
};
const domParser = new DOMParser();
const addAutoPlay = html => {
  const document = domParser.parseFromString(html, 'text/html').documentElement;
  const iframe = document.querySelector('iframe');
  if (iframe) {
    if (iframe.src.includes('?')) {
      iframe.src += '&';
    } else {
      iframe.src += '?';
    }
    iframe.src += 'autoplay=1&auto_play=1';
    iframe.allow = 'autoplay';

    // DOM parser creates html/body elements around original HTML fragment,
    // so we need to get innerHTML out of the body and not the entire document
    return document.querySelector('body').innerHTML;
  }
  return html;
};
const Card = ({
  card,
  defaultWidth = 467,
  maxTitle = 120,
  maxDescription = 200,
  compact = false,
  cacheWidth,
  onOpenMedia,
  horizontal
}) => {
  const [width, setWidth] = useState(defaultWidth);
  const [embedded, setEmbedded] = useState(false);
  useEffect(() => {
    setEmbedded(false);
  }, [card.url]);
  const trimmedTitle = trim(card.title, maxTitle);
  const trimmedDescription = trim(card.description, maxDescription);
  const handlePhotoClick = () => {
    const attachment = normalizeAttachment({
      type: 'image',
      url: card.embed_url,
      description: trimmedTitle,
      meta: {
        original: {
          width: card.width,
          height: card.height
        }
      }
    });
    onOpenMedia(ImmutableList([attachment]), 0);
  };
  const handleEmbedClick = e => {
    e.stopPropagation();
    if (card.type === 'photo') {
      handlePhotoClick();
    } else {
      setEmbedded(true);
    }
  };
  const setRef = c => {
    if (c) {
      if (cacheWidth) {
        cacheWidth(c.offsetWidth);
      }
      setWidth(c.offsetWidth);
    }
  };
  const renderVideo = () => {
    const content = {
      __html: addAutoPlay(card.html)
    };
    const ratio = getRatio(card);
    const height = width / ratio;
    return /*#__PURE__*/React.createElement("div", {
      ref: setRef,
      className: "status-card__image status-card-video",
      dangerouslySetInnerHTML: content,
      style: {
        height
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 119,
        columnNumber: 7
      }
    });
  };
  const getRatio = card => {
    const ratio = card.width / card.height || 16 / 9;

    // Constrain to a sane limit
    // https://en.wikipedia.org/wiki/Aspect_ratio_(image)
    return Math.min(Math.max(9 / 16, ratio), 4);
  };
  const interactive = card.type !== 'link';
  horizontal = typeof horizontal === 'boolean' ? horizontal : interactive || embedded;
  const className = classnames('status-card', {
    horizontal,
    compact,
    interactive
  }, `status-card--${card.type}`);
  const ratio = getRatio(card);
  const height = compact && !embedded ? width / (16 / 9) : width / ratio;
  const title = interactive ? /*#__PURE__*/React.createElement("a", {
    onClick: e => e.stopPropagation(),
    href: card.url,
    title: trimmedTitle,
    rel: "noopener",
    target: "_blank",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 143,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 150,
      columnNumber: 7
    }
  }, trimmedTitle)) : /*#__PURE__*/React.createElement("span", {
    title: trimmedTitle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 5
    }
  }, trimmedTitle);
  const description = /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    className: "flex-1 overflow-hidden p-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 157,
      columnNumber: 5
    }
  }, trimmedTitle && /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 9
    }
  }, title), trimmedDescription && /*#__PURE__*/React.createElement(Text, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 162,
      columnNumber: 9
    }
  }, trimmedDescription), /*#__PURE__*/React.createElement(HStack, {
    space: 1,
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 165,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/link.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 166,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 168,
      columnNumber: 9
    }
  }, card.provider_name)));
  let embed = '';
  const canvas = /*#__PURE__*/React.createElement(Blurhash, {
    className: "absolute w-full h-full inset-0 -z-10",
    hash: card.blurhash,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 178,
      columnNumber: 5
    }
  });
  const thumbnail = /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url(${card.image})`,
      width: horizontal ? width : undefined,
      height: horizontal ? height : undefined
    },
    className: "status-card__image-image",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 185,
      columnNumber: 5
    }
  });
  if (interactive) {
    if (embedded) {
      embed = renderVideo();
    } else {
      let iconVariant = require('@tabler/icons/player-play.svg');
      if (card.type === 'photo') {
        iconVariant = require('@tabler/icons/zoom-in.svg');
      }
      embed = /*#__PURE__*/React.createElement("div", {
        className: "status-card__image",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 206,
          columnNumber: 9
        }
      }, canvas, thumbnail, /*#__PURE__*/React.createElement("div", {
        className: "absolute inset-0 flex items-center justify-center",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 210,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-white shadow-md rounded-md p-2 flex items-center justify-center",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 211,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(HStack, {
        space: 3,
        alignItems: "center",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 212,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement("button", {
        onClick: handleEmbedClick,
        className: "appearance-none text-gray-400 hover:text-gray-600",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 213,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        src: iconVariant,
        className: "w-5 h-5 text-inherit",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 214,
          columnNumber: 19
        }
      })), horizontal && /*#__PURE__*/React.createElement("a", {
        onClick: e => e.stopPropagation(),
        href: card.url,
        target: "_blank",
        rel: "noopener",
        className: "text-gray-400 hover:text-gray-600",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 221,
          columnNumber: 19
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        src: require('@tabler/icons/external-link.svg'),
        className: "w-5 h-5 text-inherit",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 228,
          columnNumber: 21
        }
      }))))));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      ref: setRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 242,
        columnNumber: 7
      }
    }, embed, description);
  } else if (card.image) {
    embed = /*#__PURE__*/React.createElement("div", {
      className: classnames('status-card__image', 'w-full rounded-l md:w-auto md:h-auto flex-none md:flex-auto', {
        'h-auto': horizontal,
        'h-[200px]': !horizontal
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 249,
        columnNumber: 7
      }
    }, canvas, thumbnail);
  } else {
    embed = /*#__PURE__*/React.createElement("div", {
      className: "status-card__image status-card__image--empty",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 264,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: require('@tabler/icons/file-text.svg'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 265,
        columnNumber: 9
      }
    }));
  }
  return /*#__PURE__*/React.createElement("a", {
    href: card.url,
    className: className,
    target: "_blank",
    rel: "noopener",
    ref: setRef,
    onClick: e => e.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 271,
      columnNumber: 5
    }
  }, embed, description);
};
export default Card;